/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Link_Editor_Guide_DescInputs */

const en_link_editor_guide_desc = /** @type {(inputs: Link_Editor_Guide_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add links using the buttons below. Toggle the Green Checkmark to make a link Live on your storefront. Remember to Save Live Changes at the bottom to publish.`)
};

const es_link_editor_guide_desc = /** @type {(inputs: Link_Editor_Guide_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade enlaces usando los botones a continuación. Alterna la marca de verificación verde para que un enlace esté activo en tu tienda. Recuerda guardar los cambios en vivo en la parte inferior para publicar.`)
};

const fr_link_editor_guide_desc = /** @type {(inputs: Link_Editor_Guide_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez des liens à l'aide des boutons ci-dessous. Basculez la coche verte pour rendre un lien visible sur votre vitrine. N'oubliez pas d'enregistrer les modifications en bas pour publier.`)
};

const de_link_editor_guide_desc = /** @type {(inputs: Link_Editor_Guide_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge Links mit den Schaltflächen unten hinzu. Schalte das grüne Häkchen um, um einen Link in deiner Storefront live zu schalten. Vergiss nicht, die Änderungen unten zu speichern.`)
};

/** @type {(inputs: Link_Editor_Guide_DescInputs) => LocalizedString} */
const ja_link_editor_guide_desc = en_link_editor_guide_desc;

/** @type {(inputs: Link_Editor_Guide_DescInputs) => LocalizedString} */
const zh_link_editor_guide_desc = en_link_editor_guide_desc;

/** @type {(inputs: Link_Editor_Guide_DescInputs) => LocalizedString} */
const ar_link_editor_guide_desc = en_link_editor_guide_desc;

/** @type {(inputs: Link_Editor_Guide_DescInputs) => LocalizedString} */
const id_link_editor_guide_desc = en_link_editor_guide_desc;

/** @type {(inputs: Link_Editor_Guide_DescInputs) => LocalizedString} */
const it_link_editor_guide_desc = en_link_editor_guide_desc;

/** @type {(inputs: Link_Editor_Guide_DescInputs) => LocalizedString} */
const ru_link_editor_guide_desc = en_link_editor_guide_desc;

/** @type {(inputs: Link_Editor_Guide_DescInputs) => LocalizedString} */
const pt_link_editor_guide_desc = en_link_editor_guide_desc;

/** @type {(inputs: Link_Editor_Guide_DescInputs) => LocalizedString} */
const ko_link_editor_guide_desc = en_link_editor_guide_desc;

/**
* | output |
* | --- |
* | "Add links using the buttons below. Toggle the Green Checkmark to make a link Live on your storefront. Remember to Save Live Changes at the bottom to publish." |
*
* @param {Link_Editor_Guide_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const link_editor_guide_desc = /** @type {((inputs?: Link_Editor_Guide_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Editor_Guide_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_link_editor_guide_desc(inputs)
	if (locale === "es") return es_link_editor_guide_desc(inputs)
	if (locale === "fr") return fr_link_editor_guide_desc(inputs)
	if (locale === "de") return de_link_editor_guide_desc(inputs)
	if (locale === "ja") return ja_link_editor_guide_desc(inputs)
	if (locale === "zh") return zh_link_editor_guide_desc(inputs)
	if (locale === "ar") return ar_link_editor_guide_desc(inputs)
	if (locale === "id") return id_link_editor_guide_desc(inputs)
	if (locale === "it") return it_link_editor_guide_desc(inputs)
	if (locale === "ru") return ru_link_editor_guide_desc(inputs)
	if (locale === "pt") return pt_link_editor_guide_desc(inputs)
	return ko_link_editor_guide_desc(inputs)
});